// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"0e362b5c","977":"d830c9db"}[chunkId] + ".chunk.js";
};